import Cookies from 'js-cookie'

export default {
    state: {
      settings: Cookies.get('settings') ? Cookies.get('settings') : '',
      baseInfo: Cookies.get('baseInfo') ? Cookies.get('baseInfo') : '',
    },
    mutations: {
      UPDATE_SETTINGS: (state, settings)=>{
        Cookies.set('settings', settings)
        state.settings = settings;
      },
      UPDATE_BASEINFO: (state, base)=>{
        Cookies.set('baseInfo', base)
        state.baseInfo = base;
      },
    },
    actions: {
      changeSetting({ commit }, data) {
        commit('UPDATE_SETTINGS', data)
      }
    },
    getters: {
      getSettings(state){
        return JSON.parse(state.settings)
      },
      getBase(state){
        return JSON.parse(state.baseInfo)
      },
    },
  }
  


// WEBPACK FOOTER //
// ./src/store/moudles/global_info.js